<template>
  <div class="box border-box" :style="{'border': (border ? '':'none')}">
    <div class="scroll-wrap" ui-jp="mCustomScrollbar" data-mcs-theme="minimal-dark" ui-options="{theme:'minimal-dark', height: '200px'}" :style="[{'max-height': height + 'px'}, {'height': height + 'px'}, {'overflow-y': 'scroll'}]">
      <div class="box-body">
        <div v-for="(item, index) in locations" :key="index" :style="{color: fontColor(item)}">
          <label class="md-check" v-if="!item.hide">
            <!--<input type="checkbox" v-model="item.checked" @change="changeHandler(item)" :disabled="disabled(item)">-->
            <input type="checkbox" v-model="item.checked" :disabled="disabled(item)" @change="changeHandler(item)">
            <i class="blue"></i>
            <span>
              <i :class="[icon(item), 'success-mark']"></i>
              {{item.str[1]}} > {{item.str[2]}} > {{item.str[3]}} > {{item.str[4]}}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      default: function(){
        return 170;
      }
    },
    reservedLocationList: {
      type: Array,
      default: () => null
    },
    //방문객 정보 수정시
    editMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    border: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    //List 양쪽 상호 작용 시 우측편 리스트는 우선 감추어둠
    disableInitData: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    idcCode: {
      type: String
    },
    checkedLocationList: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      value:null,
      selectedItems: [],
      selectedItem: null,
      formEdit: false,
      locations: []
    }
  },
  mounted(){
    this.formEdit = this.editMode;
    this.$nextTick(() => {
      $(".scroll-wrap").mCustomScrollbar({
          axis:"y" // horizontal scrollbar
      })
    })
  },
  watch:{
    // formEdit(newVal){
    //   this.update();
    // }
    reservedLocationList(){
      // this.enableLocationList();
      // this.disableLocationList();
      // this.getAllLocation(this.idcCode);
    }
  },
  computed: {
    disabled(){
      return(item) =>{
        if(!this.formEdit)
          return true;
        if(item.reserved)
          return false;
        else
          return true;
      }
    },
    fontColor(){
      return(item) =>{

        if(!item.reserved){
          return '#999'
        }else if(item.codeValue){
          return '#f84d3a'
        }
        return '#333';
      }
    },
    icon() {
      return(item) =>{
        if(item.codeValue){
          return 'icon-security'
        }
        if(!item.reserved){
          return 'icon-fail'
        }
        return 'icon-complete';
      }
    },
  },
  created() {
    this.getAllLocation(this.idcCode);
  },
  methods: {
    getAllLocation(idcCode){
      this.$http.get('/api/private/location/list?idcCode='+idcCode)
        .then((result) => {
          //마지막 코드만 가지고옴
          let reserved = this.reservedLocationList.map(x => x[x.length-1]);

          let checked = null;
          if(this.checkedLocationList != null){
            checked = this.checkedLocationList.map(x => x[x.length-1]);

            checked = checked.filter(x => {
              return reserved.includes(x);
            });
          }


          //정렬 및 예약된거 안된거 체크
          let filtered = result.data.map(x => {

            x.hide = this.disableInitData;

            if(reserved.includes(x.code[x.code.length-1])){
              x.reserved = true;
            }else{
              x.reserved = false;
            }

            if(checked && checked.includes(x.code[x.code.length-1])){
              x.checked = true;
              this.selectedItems.push(x);
            }else{
              x.checked = false;
            }
            return x;
          }).sort((a,b) => {
            return b.code[1] < a.code[1] ? 1 : b.code[1] > a.code[1] ? -1: 0 ;
          }).sort((a,b) => {
            return b.reserved - a.reserved ;
          });

          this.locations=filtered;
        }).catch((e) => {
          console.log(e);
        })
    },
    enableLocationList(list){
      let reserved = list.map(x=> x[x.length-1]);
      this.locations = this.locations.map( x=> {
        if(reserved.includes(x.code[x.code.length-1])){
          x.reserved = true;
          x.hide = false;
        }
        x.checked = false;
        return x;
      }).sort((a,b) => {
        return b.code[1] < a.code[1] ? 1 : b.code[1] > a.code[1] ? -1: 0 ;
      }).sort((a,b) => {
        return b.reserved - a.reserved ;
      });
      // this.$forceUpdate();
    },
    // disableLocationList(){
    //   this.selectedItems.forEach(x=>{
    //     x.checked = false;
    //     x.hide = true;
    //   })
    // },
    changeHandler(item){
      this.$nextTick(() => {
        this.value = item;
        this.selectedItem = this.value;
        this.selectedItems = this.locations.filter(x=> x.checked)

        this.$emit("change", this.locations);
        this.$emit("input",this.value);
        this.$forceUpdate();
      });

    },
    confirmInput(event) {
      //this.$parent.$emit("confirmInput");
      this.$emit("confirmInput");
      this.formEdit = false;
    },

  }
}
</script>

<style>

</style>
